.answers {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 18px;
  border-bottom: 1.5px solid var(--ink);
  background: var(--sunk);
}

.hint {
  flex: 1 1 260px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink-2);
}

.all {
  min-height: 44px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
